import { years } from '../../../../Common/Filters/Filters';
import { defaultColors } from '../../../../Common/Services/contexts/ServicesChartsDataContext';
import { useServicesChartsDataContext } from './useServicesChartsDataContext';

const useServicesPerYearPercentageChart = () => {
    const { chartData, subtitles } = useServicesChartsDataContext();

    const series = subtitles.map((item, index) => {
        const data = years.map((year) => {
            const found = chartData.counterYear.find(
                (counter) => counter.ano_competencia === year
            );

            return found
                ? (index === 0
                      ? Number(found.percentage_sh_ges)
                      : Number(found.percentage_sp_ges)
                  ).toFixed(2)
                : 0;
        });

        return {
            name: item,
            data
        };
    });

    const chartConfig = {
        series: series,
        options: {
            chart: {
                type: 'bar',
                height: 400,
                stacked: true,
                toolbar: {
                    show: true
                }
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    borderRadius: 4,
                    borderRadiusApplication: 'end',
                    borderRadiusWhenStacked: 'last'
                }
            },
            yaxis: {
                max: 100
            },
            xaxis: {
                categories: years || []
            },
            legend: {
                position: 'top',
                offsetY: 10
            },
            fill: {
                opacity: 1
            },
            dataLabels: {
                enabled: true,
                formatter: (val) => `${val}%`,
                style: {
                    colors: ['#ffffff'],
                    fontSize: '11px'
                }
            },
            tooltip: {
                shared: true,
                intersect: false,
                y: {
                    formatter: (val) => (val ? `${val.toLocaleString('pt-BR')}%` : '')
                }
            },
            colors: defaultColors
        }
    };

    return {
        chartConfig
    };
};

export default useServicesPerYearPercentageChart;
